import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';

import Settings from 'project/components/project_settings';
import { fetchInvites, fetchRemoved, fetchParticipants } from 'project/ducks/creatives';
import { fetchNDAs } from 'project/ducks/ndas';
import { fetchCollaborators } from 'project/ducks/collaborators';
import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';

export function mapStateToProps({ project, user }, { params, router }) {
  const projectData = getProject({ project });
  const projectUrl = params.pageSlug || '';
  const subcategory = params.subcategory || '';

  let accessLinks = [];

  /* show tab with participants only for Elite projects */
  if (projectData.elite_only) {
    accessLinks = accessLinks.concat([{
      url: `/${subcategory}/${projectUrl}/settings/participants/`,
      name: 'Participants',
    }]);
  }

  /* show NDA-related tabs only if project requires NDAs */
  if (projectData.nda_required) {
    accessLinks = accessLinks.concat([
      {
        url: `/${subcategory}/${projectUrl}/settings/pending`,
        name: 'Pending',
      }, {
        url: `/${subcategory}/${projectUrl}/settings/approved`,
        name: 'Approved',
      }, {
        url: `/${subcategory}/${projectUrl}/settings/denied`,
        name: 'Denied',
      }
    ]);
  }

  /* 1-1 projects only have 1, pre-selected creative, so the tabs below don't make sense */
  if (!projectData.is_one_to_one) {
    accessLinks = accessLinks.concat([
      {
        url: `/${subcategory}/${projectUrl}/settings/invites`,
        name: 'Invites',
      }, {
        url: `/${subcategory}/${projectUrl}/settings/removed`,
        name: 'Removed',
      }
    ]);
  }

  return {
    userId: user.logged_in && user.profile_data.id,
    projectId: getProjectIdFromUrl(params),
    project: projectData,
    accessTabs: { links: accessLinks },
    currentURL: router.location.pathname
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);
  const subcategory = params.subcategory || '';
  return bindActionCreators({
    goToEntries: partial(push, `/${subcategory}/${projectId}/entries`),
    fetchNDAs: partial(fetchNDAs, projectId),
    fetchInvites: partial(fetchInvites, projectId),
    fetchRemoved: partial(fetchRemoved, projectId),
    fetchCollaborators: partial(fetchCollaborators, projectId),
    fetchParticipants: partial(fetchParticipants, projectId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));



// WEBPACK FOOTER //
// ./project/containers/project_settings.js